<template>
  <list-obligations
    @save="onSave"
    @delete="onDeleteAdhoc"
    :obligations="obligations"
    :name="contractorName"
    :type="resx.labels.contractor_obligation"
    :contractor-id="contractor._id"
    :contractor="contractor"
    :observations="contractor.observations"
    notes-scope="obligations"
    :notes="contractor.notes ? contractor.notes.obligations : ''"
    :notes-size="contractor.notesSize ? contractor.notesSize.obligations : null"
    heading="Obligaciones de la contratista"
    current-section="obligations"
  >
  </list-obligations>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

import listObligations from "@/components/views/contractor-company/obligations/obligations.view.vue";

export default {
  async mounted() {
    this.contractor = await contractorCompanyService.getById(
      this.$route.params.id
    );
    this.obligations = await contractorCompanyService.getObligations(
      this.$route.params.id,
      this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION
    );
  },
  components: {
    listObligations
  },
  computed: {
    contractorName() {
      return this.contractor && this.contractor.contractor
        ? this.contractor.contractor.name
        : ``;
    }
  },
  data() {
    return {
      obligations: [],
      contractor: {}
    };
  },
  methods: {
    async onSave(action) {
      const contractor = action.isNew
        ? await contractorCompanyService.addObligation(
            this.$route.params.id,
            action.item
          )
        : await contractorCompanyService.editObligation(
            this.$route.params.id,
            action.item
          );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION
        );
      }
    },
    async onDeleteAdhoc(item) {
      let contractor = await contractorCompanyService.deleteObligation(
        this.$route.params.id,
        item
      );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION
        );
      }
    },
    goBack() {
      this.$router.push(`/contractors/${this.$route.params.id}`);
    }
  }
};
</script>
